import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import FormButton from "components/buttons/FormButton";
import ModalTasksSelect from "site-apps/maintenance/tasks/ModalTasksSelect";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";

const FormIncidences = ({item, setItem, setShowCanvas, showCanvas, fetchTasks, ChoicesReason = {}, ChoicesStatus = {}}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tr} = useTranslation("routes");

    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [isLoading, setIsLoading] = useState(false);
    const [showModalTasks, setShowModalTasks] = useState(false);
    const inputRefs = useRef({name: null});

    const isEdit = !!item.id;

    useEffect(() => {
        return () => {
            unsubscribeEvent("tasks:modalselect:change", eventChangeTasks);
        };
    }, []);

    const handleOpenTaskSelector = () => {
        setShowModalTasks(true);
        subscribeEvent("tasks:modalselect:change", eventChangeTasks);
    };

    const eventChangeTasks = (e) => {
        const result = Array.isArray(e.detail) ? e.detail[0] : e.detail;
        if (result) {
            let it = {...item};
            it.task_data = {id: result.id, name: result.name};
            setItem(it);
        }
        unsubscribeEvent("tasks:modalselect:change", eventChangeTasks);
        setShowModalTasks(false);
    };

    const handleClose = () => setShowCanvas(false);

    const handleChange = (e) => {
        const {name, type} = e.target;
        const value = type === "checkbox" ? e.target.checked : e.target.value;
        let item_ = {...item};
        item_[name] = value;
        setItem(item_);
    };

    const handleSubmit = () => {
        if (!item || !item.name) {
            Alert.warning("Falta dato obligatorio", "Es necesario un Nombre").then(() => {
                inputRefs.current.name && inputRefs.current.name.focus();
            });
            return;
        }
        if (!isEdit && item.create_order && !item.task_data?.id) {
            Alert.warning("Falta dato obligatorio", "Debe seleccionar una tarea para crear la orden de trabajo");
            return;
        }
        setIsLoading(true);

        const payload = {
            id: item.id || null,
            name: item.name,
            description: item.description || "",
            reason: item.reason || "m",
            status: item.status || "P",
            task_id: item.task_data?.id || null,
            create_order: !isEdit && !!item.create_order,
        };

        axiApi
            .post("/api/maint/incidences/add/", payload)
            .then((resp) => {
                if (resp.data && resp.data.status) {
                    fetchTasks();
                    setShowCanvas(false);
                    Alert.info("Guardado", "Se ha guardado correctamente");
                } else {
                    Alert.error("Error al guardar", resp.data?.message || "Consultar con el administrador");
                }
            })
            .catch((err) => {
                console.error(err);
                Alert.error("Error servidor", "Consultar con el administrador");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const taskName = item.task_data?.name || "";

    return (
        <Offcanvas
            show={showCanvas}
            onHide={handleClose}
            placement="end"
            backdrop="static"
            style={{width: "40%", fontSize: "15px"}}>
            <Offcanvas.Header className="preview-canvas">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="bullhorn" />
                </div>
                <div className="preview-title">
                    <Offcanvas.Title>{_Tr("labels.incidence")}</Offcanvas.Title>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                <div className="container-fluid">
                    <div className="row g-3 mb-5 pb-5">
                        <div className="col-12">

                            <div className="row g-3 align-items-center">
                                <div className="col-3">
                                    <label className="col-form-label">Nombre *</label>
                                </div>
                                <div className="col-9">
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="name"
                                        value={item.name || ""}
                                        onChange={handleChange}
                                        ref={(el) => (inputRefs.current.name = el)}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Descripción</label>
                                </div>
                                <div className="col-9">
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        name="description"
                                        value={item.description || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Razón</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select name="reason" value={item.reason || 'm'} onChange={handleChange} style={{maxWidth: "160px"}}>
                                        {Object.keys(ChoicesReason).map((k) => (
                                            <option key={k} value={k}>{ChoicesReason[k]}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                            <div className="row g-3 align-items-center mt-3">
                                <div className="col-3">
                                    <label className="col-form-label">Estado</label>
                                </div>
                                <div className="col-9">
                                    <Form.Select name="status" value={item.status || 'P'} onChange={handleChange} style={{maxWidth: "160px"}}>
                                        {Object.keys(ChoicesStatus).map((k) => (
                                            <option key={k} value={k}>{ChoicesStatus[k]}</option>
                                        ))}
                                    </Form.Select>
                                </div>
                            </div>

                            {!isEdit && (
                                <>
                                    <div className="row g-3 align-items-center mt-3">
                                        <div className="col-3">
                                            <label className="col-form-label">Tarea</label>
                                        </div>
                                        <div className="col-9">
                                            <div className="input-group">
                                                <input type="text" readOnly className="form-control" value={taskName} />
                                                <button type="button" className="btn btn-outline-primary" onClick={handleOpenTaskSelector} title="Seleccionar tarea">
                                                    <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-3 align-items-center mt-3">
                                        <div className="col-3">
                                            <label className="col-form-label">Orden trabajo</label>
                                        </div>
                                        <div className="col-9">
                                            <button
                                                type="button"
                                                className={`btn ${item.create_order ? 'btn-primary' : 'btn-outline-primary'} btn-sm`}
                                                onClick={() => {
                                                    let it = {...item};
                                                    it.create_order = !item.create_order;
                                                    setItem(it);
                                                }}>
                                                <FontAwesomeIcon icon={item.create_order ? 'check-circle' : 'plus-circle'} className="me-1" />
                                                {item.create_order ? 'Creará orden al guardar' : 'Crear orden'}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                        </div>
                    </div>
                </div>
                {showModalTasks ? (
                    <ModalTasksSelect show={showModalTasks} setShow={setShowModalTasks} multiple={false} chosenIn={taskName ? [{id: item.task_data.id, name: taskName}] : []} subtitle={document.title} />
                ) : (
                    <></>
                )}
                <div className="p-3 buttons-footer">
                    <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                        <button type="button" className="btn btn-secondary" onClick={handleClose}>
                            {_Tf("labels.cancel")}
                        </button>
                        <FormButton
                            label="Guardar"
                            className="btn btn-primary ms-4"
                            isProcessing={isLoading}
                            onClick={handleSubmit}>
                            {_Tf("labels.save")}
                        </FormButton>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default FormIncidences;
